import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';
import { IAmazonActivationLinkRequest } from '../../../entity/interface/iEntitlements';
export interface IGetAmazonActivationLinkUseCase {
    execute(payload: IAmazonActivationLinkRequest, apiToken: string | { [key: string]: string }): Promise<any>;
}

export class GetAmazonActivationLinkUseCase implements IGetAmazonActivationLinkUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get getAmazonActivationLinkRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(payload: IAmazonActivationLinkRequest, apiToken: string | { [key: string]: string }): Promise<any> {
        return this.getAmazonActivationLinkRepository.getAmazonActivationLink(payload, apiToken);
    }
}
